import React from 'react';

export default function MetricusInput({
  label,
  helperText='',
  multiline=false,
  rows=3,
  className='',
  ...props
}){
  const Control=multiline?'textarea':'input';
  return <label className={`metricus-field ${className}`.trim()}>
    {label&&<span className="metricus-field-label">{label}</span>}
    <Control {...props} rows={multiline?rows:undefined} className="metricus-input"/>
    {helperText&&<span className="metricus-field-help">{helperText}</span>}
  </label>;
}
